import { render, staticRenderFns } from "./gmToolNewemail.vue?vue&type=template&id=4b2090f4&scoped=true&"
import script from "./gmToolNewemail.vue?vue&type=script&lang=js&"
export * from "./gmToolNewemail.vue?vue&type=script&lang=js&"
import style0 from "./gmToolNewemail.vue?vue&type=style&index=0&id=4b2090f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2090f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b2090f4')) {
      api.createRecord('4b2090f4', component.options)
    } else {
      api.reload('4b2090f4', component.options)
    }
    module.hot.accept("./gmToolNewemail.vue?vue&type=template&id=4b2090f4&scoped=true&", function () {
      api.rerender('4b2090f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/email/gmToolNewemail.vue"
export default component.exports